import { linkHandler } from '../LinkHandler/LinkHandler';
import { Routes } from 'config/routes';

export const getRouteKeyFromUrl = (url: string): keyof typeof Routes | false => {
  const trimUrlScheme = url.split('//');
  if (trimUrlScheme.length > 1) {
    trimUrlScheme.shift();
  }
  const urlParts = trimUrlScheme.join('//').split('/');
  urlParts.shift();

  const routes = linkHandler.getAll();
  const _url = `/${urlParts.join('/')}`;

  const key = Object.keys(routes).find((routeKey) => routes[routeKey].path === _url);

  if (!key) {
    return false;
  }
  return key as keyof typeof Routes;
};
